export function getNumberOfNights(arrivalDate: Date, departureDate: Date): number {
    const timeDiff: number = Math.abs(departureDate.getTime() - arrivalDate.getTime());
    return Math.ceil(timeDiff / (1000 * 3600 * 24));
}

export function convertPriceStringToNumber(value: string | number | null): number | null {
    if (typeof value === 'string') {
        return Number(value.replace(',', '.'));
    }

    return value;
}

export function getCompanionData(container: HTMLElement): TravelPartyDataInterface {
    const adultsValue = (<HTMLInputElement>container.querySelector('[data-field-name="adult"]'))
        ?.value;
    const childrenValue = (<HTMLInputElement>container.querySelector('[data-field-name="child"]'))
        ?.value;
    const babiesValue = (<HTMLInputElement>container.querySelector('[data-field-name="baby"]'))
        ?.value;
    const petsValue = (<HTMLInputElement>container.querySelector('[data-field-name="pet"]'))?.value;

    return {
        adults: adultsValue ? Number(adultsValue) : undefined,
        children: childrenValue ? Number(childrenValue) : undefined,
        babies: babiesValue ? Number(babiesValue) : undefined,
        pets: petsValue ? Number(petsValue) : undefined
    };
}
